import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WorkflowContextService } from '../../../../services';

@Component({
    selector: 'app-global-admin',
    templateUrl: './global-admin.component.html',
    styleUrls: ['./global-admin.component.css'],
    standalone: false
})
export class GlobalAdminComponent implements OnInit {
  topMargin: number;

  constructor(private _context: WorkflowContextService, private _router: Router) {}

  ngOnInit() {
    this._context.client$.emit(null);
  }

  setTopMarginForNavbar(pixelHeight: number) {
    this.topMargin = pixelHeight;
  }

  get isWideLayoutRoute(): boolean {
    return this._router.url.includes('/upload-inspection-admin');
  }
}
